module.exports = __webpack_public_path__ + "static/media/edit_segment_name_desktop.1c4b128f.svg";